import { render, staticRenderFns } from "./MultiTransferForm.vue?vue&type=template&id=3c622ea9"
import script from "./MultiTransferForm.vue?vue&type=script&lang=js"
export * from "./MultiTransferForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MultiTransferForm.vue?vue&type=style&index=1&id=3c622ea9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports